<template>
  <div class="flex items-start">
    <aside class="h-screen w-1/4 bg-gray-900 p-6 text-white">
      <div class="flex justify-between">
        <span class="text-gray-500 flex itesm-center">
          بروزرسانی در
          <RefreshIcon class="w-4 cursor-pointer text-green-500 mr-2" @click="getMonitorOrders"/>
        </span>
        <span id="timer" class="text-lg"></span>
      </div>

      <select class="w-full bg-gray-800 p-2 rounded-lg mt-2" v-model="selectedMonitor">
        <option :value="{}" disabled>انتخاب مانیتورینگ</option>
        <option
            v-for="monitor in monitors" :key="monitor.id" :value="monitor">
          {{ monitor.name }}
        </option>
      </select>

      <div class="flex justify-between gap-4 mt-8">
        <Button class="" @click="chargeFoodModal = true" v-if="selectedMonitor.isEnableCharge">شارژ غذا</Button>
        <button class="w-full border-2 border-yellow-600 rounded-lg py-2" v-if="selectedMonitor.isEnableDeliveriBoy"
                @click="deliveryBoyModal = true"
                @mousedown="toggleAnimation($event)" @mouseup="toggleAnimation($event)">غذا بر
        </button>
        <button class="w-full border-2 border-yellow-600 rounded-lg py-2"
                @click="reportModal = true">گزارش
        </button>
      </div>

      <div class="flex mt-4 items-center">
        <label class="shrink-0">وضعیت غذا</label>
        <select class="w-full bg-gray-800 p-2 rounded-lg mr-4" v-model="selectedState">
          <option :value="{}" disabled>انتخاب وضعیت</option>
          <option
              v-for="state in monitorStates" :key="state.id" :value="state">
            {{ state.name }}
          </option>
        </select>
      </div>

      <div class="mt-4 border-2 rounded-lg p-4"
           v-for="(summary, index) in monitorSummary"
           :key="summary"
           :class="index === 0 ? 'border-red-400' : 'border-yellow-500'">
        <h1 class="text-center">{{ summary.name }}</h1>
        <hr class="mt-2" :class="index === 0 ? 'border-red-400' : 'border-yellow-400'">
        <table class="w-full text-sm mt-4">
          <tbody>
          <tr v-for="food in summary.foodList"
              :key="food.foodId">
            <td class="py-2">{{ food.name }}</td>
            <td>{{ food.qty }} عدد</td>
          </tr>
          </tbody>
        </table>
      </div>

    </aside>

    <div class="w-full relative flex flex-wrap gap-x-8 gap-y-16 p-8 mt-8">

      <MonitorOrder
          v-for="order in orders"
          :key="order.Id"
          :order="order"
          :monitorId="selectedMonitor.id"
          :isDetailEnable="selectedMonitor.isEnableServiceDetail"
          :states="monitorStates"
          @update="getMonitorOrders"/>

      <div class="absolute flex items-center justify-center top-0 right-0 w-full h-full bg-gray-800/80" v-if="loading">
        <LoadingSpinner class="w-20 h-20 text-yellow-500"/>
      </div>
    </div>

  </div>

  <DeliveryBoyModal
      v-if="selectedMonitor.id"
      :show="deliveryBoyModal"
      :monitorId="selectedMonitor.id"
      @click="deliveryBoyModal = false"/>

  <ChargeFoodModal
      v-if="selectedMonitor.id"
      :show="chargeFoodModal"
      :monitorId="selectedMonitor.id"
      @click="chargeFoodModal = false"/>

  <ReportModal
      v-if="selectedMonitor.id"
      :show="reportModal"
      :monitorId="selectedMonitor.id"
      @click="reportModal = false"/>
</template>

<script>
import Button from "../../components/General/Button";
import {getMonitorOrders, getMonitors, getMonitorSummaryList} from "../../API/API";
import MonitorOrder from "../../components/Monitoring/MonitorOrder";
import DeliveryBoyModal from "../../components/Modal/DeliveryBoyModal";
import ChargeFoodModal from "../../components/Modal/ChargeFoodModal";
import LoadingSpinner from "../../components/General/LoadingSpinner";
import ReportModal from "@/components/Modal/ReportModal";
import {RefreshIcon} from "@heroicons/vue/outline";

export default {
  name: "Monitoring",
  components: {ReportModal, LoadingSpinner, ChargeFoodModal, DeliveryBoyModal, MonitorOrder, Button, RefreshIcon},
  data() {
    return {
      loading: true,

      monitors: [],
      selectedMonitor: {},

      monitorStates: [],
      selectedState: {},

      monitorSummary: [],

      orders: [],

      deliveryBoyModal: false,
      chargeFoodModal: false,
      reportModal: false
    }
  },
  async created() {
    this.monitors = (await getMonitors()).data.result
    this.selectedMonitor = this.monitors[0]

    this.monitorStates = this.selectedMonitor.states
    this.selectedState = this.monitorStates[0]

    this.countdown(2 * 60);
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-yellow-500')
    },
    async getMonitorOrders() {
      this.loading = true
      this.orders = []
      this.monitorSummary = (await getMonitorSummaryList(this.selectedMonitor.id)).data.result
      this.orders = (await getMonitorOrders(this.selectedMonitor.id, this.selectedState.id)).data.result
      this.loading = false
    },
    countdown(duration) {
      let timer = duration, minutes, seconds;
      let vm = this

      setInterval(function () {
        minutes = parseInt(timer / 60, 10)
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        document.getElementById('timer').textContent = minutes + ":" + seconds;

        if (--timer < 0) {
          timer = duration;
          vm.getMonitorOrders()
        }
      }, 1000);
    }
  },
  watch: {
    'selectedState'() {
      this.getMonitorOrders()
    },
    'selectedMonitor'() {
      this.monitorStates = this.selectedMonitor.states
      this.selectedState = this.monitorStates[0]
      this.getMonitorOrders()
    }
  }
}
</script>

<style scoped>

</style>